<template>
  <div class="relative overflow-hidden">
    <!-- background layers -->
    <div class="absolute inset-0 z-0">
      <!-- 1) gradient: vertical on mobile, horizontal on lg+ -->
      <div
        class="absolute inset-0 z-0
           bg-[linear-gradient(to_bottom,#9e1d46_0%,#c52a4c_30%,#e43b5f_60%,transparent_100%)]
           lg:bg-[linear-gradient(90deg,#9e1d46_0%,#c52a4c_30%,#e43b5f_50%,transparent_100%)]"
      />

      <!-- 2) image: full-cover on mobile, right-half on lg+ -->
      <div
        class="absolute inset-0 top-[50%] bg-cover bg-center z-[-1]
           lg:inset-y-0 lg:right-0 lg:w-1/2 lg:inset-x-auto"
        :style="{ backgroundImage: `url(${imageSrcLarge})` }"
        aria-hidden="true"
      />
    </div>

    <div class="relative z-[2]">
      <KfContainer>
        <div class="grid grid-cols-2 pt-36 pb-80 mb-12 lg:pt-48 lg:pb-24">
          <div class="col-span-2 lg:col-span-1">
            <kf-heading
              v-if="ctaTitle"
              tag="h2"
              class="text-white text-7xl font-bold mb-6"
            >
              {{ ctaTitle }}
            </kf-heading>

            <p
              v-if="ctaIntro"
              class="text-white text-lg mb-6"
            >
              {{ ctaIntro }}
            </p>

            <kf-link
              :href="link.href"
              :target="link.target"
              type="button-secondary"
              class="mt-4 h-12 text-base w-fit !border-white !text-white"
            >
              {{ link.label }}
            </kf-link>
          </div>
        </div>
      </KfContainer>
    </div>
    <KfCurve
      class="absolute -bottom-[2px] left-0 w-full z-[3]"
      curve-alignment="left"
      :curve-svg-color="colorBottom"
    />
  </div>
</template>

<script>
import KfCurve from '@/components/base/curve/Curve.vue';
import KfHeading from '@/components/base/heading/Heading.vue';
import KfLink from '@/components/base/link/Link.vue';
import KfContainer from '@/components/layout/container/Container.vue';

export default {
  name: 'CallToAction',
  components: { KfContainer, KfHeading, KfLink, KfCurve },
  props: {
    ctaTitle: {
      type: String,
      default: null,
    },
    ctaIntro: {
      type: String,
      default: null,
    },
    colorTop: {
      type: String,
      default: 'white'
    },
    colorBottom: {
      type: String,
      default: 'white'
    },
    imageSrcLarge: {
      type: String,
      default: null,
    },
    imageAlt: {
      type: String,
      default: null,
    },
    link: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
